import React, {useState, useContext} from 'react';
import {Button, Typography, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Grid, MenuItem, Backdrop, CircularProgress, DialogContentText} from '@mui/material';
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Checkbox, FormGroup, FormControlLabel, LinearProgress} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import xlsx from 'json-as-xlsx';
import Papa from 'papaparse';
import Header from './header';
import { API } from '../conf';
import { TokenContext } from '../App';
import Import from './import';
import UserRow from './user-row';


export default function ManageUser(props) {
    const [load, setLoad] = useState(true)
    const [sending, setSend] = useState(false)
    const [data, setData] = useState([])
    const [show_imported, setShow_imported] = useState(false)
    const [imported, setImported] = useState(<Import/>)
    const [show, setShow] = useState(false)
    const [departements, setDepartmt] = useState([])
    const [checkSiege, setCheck1] = useState(true)
    const [checkPastors, setCheck2] = useState(false)
    const [nom , setNom] = useState()
    const [prenom , setPrenom] = useState()
    const [mail , setMail] = useState()
    const [departement , setDept] = useState()
    const [selectMode, setSelect] = useState(true)
    const [msg, setMsg] = useState()
    const [token, setToken] = useContext(TokenContext)

    const rm_token =()=>{
        setToken()
        return null
    }
    const get_siege = () =>{ return new Promise((resolve, reject) => {
        fetch(API.concat('/utilisateurs/siege/all'), {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            },
        })
        .then(response=> response.status === 200 ? response.json() : response.status === 401 ? setToken() : null)
        .then(json => resolve(json))
    })}

    const get_pasteurs = async() =>{ return new Promise((resolve, reject) => {
        fetch(API.concat('/utilisateurs/pasteur'), {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            },
        })
        .then(response=> response.status === 200 ? response.json() : response.status === 401 ? rm_token() : null)
        .then(json => resolve(json))  
    })}

    function get_departements() {
        return new Promise((resolve, reject) => {
            fetch(API.concat('/departements'), {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                },
            })
            .then(response=> response.status === 200 ? response.json() : null)
            .then(json => resolve(json))  
        })
    }

    function handleCheck1() {
        setLoad(true)
        setCheck1(!checkSiege)
        if (checkSiege) {
            const filtre = data.filter(row => row.departement === 'pasteur')
            setData(filtre)
            setLoad(false)
        } else {
            get_siege().then(json => {
                if(json !== null) {
                    setData(old => (old.concat(json)))
                }
                setLoad(false)
            })
        }
    }

    function handleCheck2() {
        setLoad(true)
        setCheck2(!checkPastors)
        if (!checkPastors) {
            get_pasteurs()
            .then(json =>{
                if(json !== null) setData(old => (old.concat(json)))
                setLoad(false)
            })
        } else {
            setData(old => old.filter(row => row.departement !== 'pasteur'))
            setLoad(false)
        }
    }

    function handleAddSubmit() {
        if(nom&& prenom&& mail){
            setSend(true)
            setMsg()
            fetch(API.concat('/utilisateur/register'), {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token,
                },
                body: JSON.stringify({
                    nom: nom,
                    prenom: prenom,
                    mail: mail,
                    departement: departement
                })
            })
            .then(response=> {
                return response.status === 200 ? response.json() : response.status === 409 ? response.text() : response.status === 401 ? rm_token() : null
            })
            .then(result => {
                if(typeof result === 'string'){
                    setMsg('**'.concat(result))
                } else if (result === null) {
                    setMsg('**Une erreur est survenue, veuillez réessayer ultérieurement')
                } else {
                    reset_add_form(true);
                    if (checkSiege && result[0].departement !== 'pasteur') {
                        setData(old => old.concat([result[0]]))
                    } else if(result !== null && checkPastors && result[0].departement === 'pasteur') {
                        setData(old => old.concat([result[0]]))
                    }
                }
                setSend(false)
            })
        } else setMsg('**Vous devez remplir tous les champs obligatoires')
    }

    function reset_add_form(keep_open) {
        setShow(keep_open);setNom('');setPrenom('');setMail('');
        if(checkPastors && !checkSiege) {setDept('pasteur')} else setDept('')
        setSelect(true)
        get_departements().then(json => {if(json !== null) setDepartmt(json.concat(['pasteur', 'nouveau département']))})
    }

    function update_user(old_user, updated_user) {
        let dt = data
        dt[(dt.indexOf(old_user))] = updated_user
        setData(dt)
    }

    function rm(to_delete) {
        setData(old => old.filter(row => row._id !== to_delete))
    }

    function handleExport() {
        const siege = data.filter(row => row.departement !== 'pasteur')
        const pasteurs = data.filter(row => row.departement === 'pasteur')

        let excel = [
            {
              sheet: "Employés Siège",
              columns: [
                { label: "Nom", value: (row) => row.nom.charAt(0).toUpperCase() + row.nom.slice(1) }, 
                { label: "Prénom", value: (row) => row.prenom.charAt(0).toUpperCase() + row.prenom.slice(1) }, 
                { label: "Mail", value: "mail" }, 
                { label: "Département", value: (row) => row.departement.charAt(0).toUpperCase() + row.departement.slice(1) }, 
              ],
              content: siege,
            },
            {
              sheet: "Pasteurs",
              columns: [
                { label: "Nom", value: (row) => row.nom.charAt(0).toUpperCase() + row.nom.slice(1) }, 
                { label: "Prénom", value: (row) => row.prenom.charAt(0).toUpperCase() + row.prenom.slice(1) }, 
                { label: "Mail", value: "mail" }, 
              ],
              content: pasteurs,
            },
        ]
          
        let settings = {
            fileName: `liste_employés_FEAM_${Date.now().toLocaleString()}`, // Name of the resulting spreadsheet
            extraLength: 3, // A bigger number means that columns will be wider
            writeMode: "writeFile", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
            writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
        }
          
          xlsx(excel, settings) // Will download the excel file
    }

    function handleImport(event) {
        event.preventDefault();

        let userFile = event.target.files[0];

        Papa.parse(userFile, {
            header: true,
            complete: function(results) {
                let users = results.data
                let headers = Object.keys(users[0])
                setShow_imported(true)

                if(headers.includes('nom') && headers.includes('prenom') && headers.includes('mail') && headers.includes('departement')){
                    setImported(<Import users={users} updateData={setData} old={data} show={setShow_imported} />)
                } else {
                    setImported(<Import msg='Entêtes invalides!'/>);
                }
            }
        })
    }

    React.useEffect(()=>{
        const launch = async() =>{
            get_siege().then(json => {
                if(json !== null) setData(json)
                setLoad(false)
            })
        }

        launch();
    }, []);

    const input_file_ref = React.createRef()

    return(
        <div style={{position:'absolute', right:0, left:0, top:0, bottom:0}}>
            <Header title='Gestion des employés'/>
            <div style={{display: 'flex', justifyContent: 'space-between',  padding: '5% 50px 0px 50px'}}>
                <FormGroup style={{display: 'flex', flexDirection:'row', alignItems:'center'}}>
                    <Typography variant='body1' fontWeight='bold' marginRight={2}>Filtres: </Typography>
                    <FormControlLabel control={<Checkbox color='coral' disabled={load} checked={checkSiege} onChange={handleCheck1}/>} label="Employés siège" />
                    <FormControlLabel control={<Checkbox color='coral' disabled={load} checked={checkPastors} onChange={handleCheck2}/>} label="Pasteurs" />
                </FormGroup>
                <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                    <input type='file' name='employes_file' accept='.csv' ref={input_file_ref} hidden onChange={(event)=>{
                        handleImport(event)
                    }} />
                    <Button variant='contained' style={{marginRight:20}} color='valide' onClick={()=>{ 
                        setShow(true)
                        get_departements().then(json=> {if(json !== null) setDepartmt(json.concat(['pasteur', 'nouveau département']))})
                        if(checkPastors && !checkSiege) setDept('pasteur')
                    }}>
                        <span style={{textTransform:'uppercase'}}>Ajouter un employé</span>
                    </Button>
                    <Button variant='contained' style={{marginRight:20}} color='verdigris' onClick={()=> input_file_ref.current.click()}>
                        <span style={{textTransform:'uppercase'}}>Importer</span>
                    </Button>
                    <Button variant='contained' color='purple' onClick={handleExport}>
                        <span style={{textTransform:'uppercase'}}>Exporter</span>
                    </Button>
                </div>
            </div>
            <div style={{display: 'flex', justifyContent:'center'}}>
                <TableContainer sx={{padding: '20px', margin: '20px 80px'}}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead component={Paper} elevation={4}>
                        <TableRow>
                            <TableCell align='center'><span style={{fontWeight:'bold'}}>Nom</span></TableCell>
                            <TableCell align="center"><span style={{fontWeight:'bold'}}>Prénom</span></TableCell>
                            <TableCell align="center"><span style={{fontWeight:'bold'}}>Département</span></TableCell>
                            <TableCell align="center"><span style={{fontWeight:'bold'}}>Actions</span></TableCell>
                        </TableRow>
                        </TableHead>

                        {!load && <TableBody>
                        {data.map((row) => (
                            <UserRow user={row} update_data={[update_user, rm]} key={row._id} />
                        ))}
                        </TableBody>}
                    </Table>
                    {load && <LinearProgress color='coral' sx={{width: '100%'}}/>} 
                </TableContainer>
            </div>
            {/*Import dialog */}
            <Dialog open={show_imported} onClose={()=> setShow_imported(false)} sx={{borderRadius: 5}} maxWidth={false} >
                <DialogTitle sx={{textAlign: 'center', fontSize:26, fontWeight:'bold'}}>Importer des employés</DialogTitle>
                <DialogContent>
                    {imported}
                </DialogContent>
            </Dialog>
            {/* add form */}
            <Dialog open={show} onClose={()=> reset_add_form(false)} sx={{borderRadius:5}} >
                <DialogTitle sx={{textAlign: 'center', fontWeight: 'bold'}}>Enregistrer un employé</DialogTitle>
                <DialogContent>
                    <DialogContentText><span style={{color: 'coral', fontSize:13}}>{msg}</span></DialogContentText>
                    <Grid container spacing={{xs: 3, md: 5}}>
                        <Grid item>
                        <TextField
                        margin="normal"
                        required
                        id="nom"
                        label="Nom"
                        name="nom"
                        autoComplete="family-name"
                        autoFocus
                        value={nom}
                        onChange={(event)=> setNom(event.target.value)}
                        />
                        </Grid>
                        <Grid item>
                        <TextField
                        margin="normal"
                        required
                        label="Prénom"
                        name="prenom"
                        autoComplete="given-name"
                        value={prenom}
                        onChange={(event)=> setPrenom(event.target.value)}
                        />
                        </Grid>
                    </Grid>
                    <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="Adresse mail"
                    name="email"
                    autoComplete="email"
                    value={mail}
                    onChange={(event)=> setMail(event.target.value)}
                    />
                    <TextField
                    id="outlined-select-currency"
                    select={selectMode}
                    fullWidth
                    style={{marginTop: 16}}
                    label="Département"
                    value={departement}
                    onChange={(e)=> e.target.value === 'nouveau département' ? setDept() : setDept(e.target.value)}
                    >
                    {departements.map((option) => (
                        <MenuItem key={option} value={option} style={option === 'nouveau département' ?{ justifyContent: 'center', borderWidth:1, borderColor:"grey"} : {}}>
                            {option === 'nouveau département' ?
                            <Button variant='outlined' color='purple' onClick={()=> setSelect(false)}>
                                <AddIcon color='purple'/> 
                                <span style={{textTransform: 'capitalize', color: 'purple', fontSize:16}}>{option}</span>
                            </Button> :
                            <span style={{textTransform: 'capitalize'}}>{option}</span> }
                        </MenuItem>
                    ))}
                    </TextField>
                </DialogContent>
                <DialogActions sx={{justifyContent:'center', marginBottom: 2}}>
                    <Button variant='contained' color='grey' onClick={()=> reset_add_form(false)}><span style={{ fontWeight:'bold'}}>Annuler</span></Button>
                    <Button variant='contained' color='valide' 
                    onClick={handleAddSubmit}><span style={{color:'#000', fontWeight:'bold'}} disabled={sending || !nom||!prenom||!mail}>Enregistrer</span></Button>
                </DialogActions>
                <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={sending}
                >
                    <CircularProgress color="valide" />
                </Backdrop>
            </Dialog>
        </div>
    )
}